const warningModal = {
    header: 'Zapisz zmiany',
    body: 'Wprowadzone zmiany nie zostały zapisane. Czy napewno chcesz zakończyć edycję?',
    confirm: 'ZAKOŃCZ',
    cancel: 'WRÓĆ'
};

export default warningModal;